module.exports = __webpack_public_path__ + "static/media/photo.704c4d72.jpg";